import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    canCheckoutWithCart,
    getCurrentCartState,
    isCartCheckoutDisabled,
    isCartEmpty,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import preloadCheckoutShippingData from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/PreloadCheckoutShippingData";
import translate from "@insite/client-framework/Translate";
import CartTotalDisplay from "@insite/content-library/Components/CartTotalDisplay";
import Button from "@insite/mobius/Button";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Cart } from "@insite/client-framework/Services/CartService";
import siteMessage from "@insite/client-framework/SiteMessage";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import CartLineQuantity, { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { styles } from "@insite/content-library/Widgets/ContactUs/AvailableTopics";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import { Hidden, Link } from "@insite/mobius/index";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { getunitOfMeasureDisplay } from "@NA/Overrides/Components/ProductPrice";
import { isPriceAvailable, saleEndDate } from "@NA/Utils/Utility";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import getLocalizedCurrency from "@insite/client-framework/Common/Utilities/getLocalizedCurrency";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { getUnitListPrice, getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import MiniCartModal from "@NA/Widgets/Cart/MiniCartModal";
import MiniCartSaleInfo from "@NA/CustomComponents/MiniCartSaleInfo";

interface OwnProps {
    cartLine: CartLineModel;
    extendedStyles?: MiniCartLineStyles;
    quantityOrdered?: any;
    qtyOrdered?: number;
    onModalClose: () => void;
}

export interface MiniCartLineStyles {
    container?: GridContainerProps;
    productImageGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    orderLineInfoGridItem?: GridItemProps;
    orderLineInfoContainer?: GridContainerProps;
    infoLeftColumn?: GridItemProps;
    infoLeftColumnContainer?: GridContainerProps;
    productBrandAndDescriptionGridItem?: GridItemProps;
    productBrand?: ProductBrandStyles;
    productDescription?: ProductDescriptionStyles;
    productErpNumberText?: TypographyPresentationProps;
    productPriceAndQuantityGridItem?: GridItemProps;
    productPriceAndQuantityContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    quantityGridItem?: GridItemProps;
    quantity?: CartLineQuantityStyles;
    extendedUnitNetPriceGridItem?: GridItemProps;
    extendedUnitNetPrice?: SmallHeadingAndTextStyles;
    orderLineInfoTitleContainer?: GridContainerProps;
    orderLineInfoTitleGridItem?: GridItemProps;
    qtyOrderedGridItem?: GridItemProps;
    totalOrderedGridItem?: GridItemProps;
    mobilePriceGridItem?: GridItemProps;
    orderLineInfoTitles?: TypographyPresentationProps;
    priceTypography?: TypographyPresentationProps;
    priceTotalTypography?: TypographyPresentationProps;
    regularPriceTypography?: TypographyPresentationProps;
    productBrandStyles?: LinkPresentationProps;
    orderLineInfoItemTitle?: TypographyPresentationProps;
    qtyTitleStylingBelowlgScreen?: TypographyPresentationProps;
    totalTitleStylingBelowlgScreen?: TypographyPresentationProps;
    totalSupStyles?: TypographyPresentationProps;
    centsSupStyles?: TypographyPresentationProps;
    unitSupStyles?: TypographyPresentationProps;
    productNameStyles?: TypographyPresentationProps;
    minicartMarketingTag?: InjectableCss;
    savingsMessageText?: TypographyPresentationProps;
    clearanceStirkeprice?: InjectableCss;
    clearanceSaleEnd?: InjectableCss;
    clearancecartContainer?: InjectableCss;
    orderLineInfoItemContainer?: InjectableCss;
    orderLineInfoPriceContainer?: InjectableCss;
    orderLineInfoQtyContainer?: InjectableCss;
    orderLineInfoTotalContainer?: InjectableCss;

}

export const miniCartLineStyles: MiniCartLineStyles = {
    totalSupStyles: {
        css: css`
            font-size: 12.7px;
            position: relative;
            font-weight: 900;
            top: 0.8px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: 12px;
                            top: 3px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    centsSupStyles: {
        css: css`
            font-size: 12.7px;
            position: relative;
            font-weight: 900;
            top: -1px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: 12px;
                            top: 2px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    unitSupStyles: {
        css: css`
            font-size: 12.7px;
            position: relative;
            font-weight: normal;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: 12px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    savingsMessageText: {
        italic: true,
        size: "12px",
    },
    container: {
        gap: 20,
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            padding-top: 13px;
            > ${GridOffset}{
                width:100%;
                margin:0px;
                > ${GridItemStyle} {
                    padding:0px;
                }
            }
            @media only screen and (max-width: 1080px) {
                padding-bottom: 18px;
                max-width: 100%;
            }
        `,
    },
    productImageGridItem: {
        width: [4, 2, 2, 1, 1],
        css: css`
            flex-direction: column;
            max-width: 116px;
            min-width: 116px;
            height: auto;
            padding:0px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 10px 0px;
                            align-items: center;
                            text-align: center;
                        `,
                    ],
                    "max",
                );
            }}
            ${StyledButton} {
                img {
                    max-width: 92px;
                    min-width: 92px;
                    object-fit: contain;
                    height: auto;
                    margin:0px;
                    margin-left: 15px;
                    ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                                margin-left: 0px;
                            `,
                    css`
                                margin-left: 10px;
                            `,
                    css`
                                max-width: 98px;
                                min-width: 98px;
                                margin-left: 20px;
                            `,
                ]);
            }}
                }
            }
        `,
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: auto;
                            height: auto;
                        `,
                        css`
                            width: auto;
                            height: auto;
                        `,
                        css``,
                        css``,
                        css``,
                    ])}
            `,
        },
    },
    orderLineInfoGridItem: {
        width: 12,
        css: css`
            padding: 0 10px 33px 10px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 10px;
                        `,
                        css`
                            padding: 10px;
                        `,
                        css`
                            padding: 10px 20px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    orderLineInfoContainer: {
        gap: 20,
        css: css`
            > ${GridOffset}{
                width:100%;
                margin:0px;
                padding:0px;
                padding-top: 13.5px;
                padding-bottom: 23px;                
            }
        `,
    },
    infoLeftColumn: {
        width: [8, 10, 10, 5, 5],
        css: css`
            
            padding:0px;
            padding-left: 20px;
            padding-right:20px;
            flex-basis:initial !important;
            max-width:400px !important;
            min-width:399px !important;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        padding-left: 10px;
                        max-width: calc(100% - 33.333333%) !important;
                        min-width: initial !important;
                    `,
                    css`
                        padding-left: 20px;
                        max-width: calc(100% - 33.333333%) !important;
                        min-width: initial !important;
                    `,
                    css`
                        padding-left: 35px;
                    `,
                    null,
                    null,
                ]);
            }}
        `,
    },
    infoLeftColumnContainer: {
        gap: 10,
        css: css`
        > ${GridOffset}{
                width:100%;
                margin:0px;
                padding-left: 0px;
                max-width:400px;             
            }
        `,
    },
    productBrandAndDescriptionGridItem: {
        css: css`
            flex-direction: column;
            padding-bottom: 2.5px;
        `,
        width: 12,
    },
    productBrand: {
        nameText: {
            color: "text.main",
        },
    },
    productErpNumberText: {
        css: css`
            width: 116px;
            word-wrap: break-word;
            color: #666;
            font-size: 12px;
            font-weight: 600;
            padding: 5px 0;
            ${TypographyStyle} {
                display: block;
                font-size: 10px;
                line-height: normal;
                font-weight: 600;
            }
        `,
    },
    productPriceAndQuantityGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    productPriceAndQuantityContainer: {
        gap: 10,
    },
    priceGridItem: {
        width: [0, 0, 0, 3, 3],
        css: css`
            padding:0px;
            flex:1;
            max-width:initial;
        `,
    },
    quantityGridItem: {
        width: 3,
    },
    extendedUnitNetPriceGridItem: {
        width: 4,
        css: css`
            flex-direction: column;
        `,
    },
    extendedUnitNetPrice: {
        text: {
            weight: 700,
        },
    },
    orderLineInfoTitleContainer: {
        gap: 20,
        css: css`
            border-bottom: 1px solid ${getColor("common.border")};
            > ${GridOffset}{
                width:100%;
                margin:0px;
                justify-content: flex-start;
                ${GridItemStyle}{
                    padding: 0px;
                    padding-bottom: 8.5px;
                    &:nth-child(2){
                        flex:1;
                    }
                    &:nth-child(3){
                        justify-content: center;
                    }
                    &:last-child{
                        justify-content: flex-start;
                        padding-left: 60px;
                        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                                    
                                    padding: 0px;
                                `,
                    css`
                                   
                                    padding: 0px;
                                `,
                    css``,
                    css``,
                    css``,
                ])}
                    }
                }
            }
        `,
    },
    orderLineInfoItemContainer: {

        css: css`
           padding:0px;
           width: 515px;
           padding-left: 15px;
           max-width: 515px;
        `,
    },
    orderLineInfoPriceContainer: {

        css: css`
            padding:0px;
            width: 258px;
            max-width: 258px;
        `,
    },
    orderLineInfoQtyContainer: {

        css: css`
           padding:0px;
           width: 42px;
            text-align: center;
        `,
    },
    orderLineInfoTotalContainer: {

        css: css`
           padding:0px;
            width: auto;
        `,
    },
    orderLineInfoTitleGridItem: {
        width: [0, 0, 0, 12, 12],
        css: css`
           padding:0px;
        `,
    },
    qtyOrderedGridItem: {
        width: [6, 6, 6, 1, 1],
        css: css`
        justify-content: center;
        padding:0px;
            ${TypographyStyle} {
                font-weight: normal;
                line-height: 32px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: flex-start;
                        padding: 10px;
                    `,
                    css`
                        justify-content: flex-start;
                        padding: 10px 0;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    totalOrderedGridItem: {
        width: [6, 6, 6, 2, 2],
        css: css`
        padding:0px;
        padding-left: 60px;
        white-space: nowrap !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 10px;
                        `,
                        null,
                        css`
                            padding-left: 10px;
                            justify-content: flex-end;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
                
                ${TypographyStyle} { 
                    ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, css` top: 5px; `,], "max",);
            }}
 
                    &:last-child {
                        top: 0px;
                        ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, null, css` top: 4px; `,], "max",);
            }}
                    }
                }
        `,
    },
    mobilePriceGridItem: {
        width: [12, 12, 12, 0, 0],
    },
    orderLineInfoTitles: {
        weight: "bold",
        size: 14,
        css: css`
            margin-bottom: 0px;
        `,
    },
    priceTypography: {
        css: css`
            font-weight: 900;
            letter-spacing: normal;
        `,
    },
    priceTotalTypography: {
        css: css`
            font-size: 27.2px;
            font-weight: 900;
            line-height: 1.05;
            letter-spacing: normal;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            font-size: 20px;
                            line-height: 32px;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    regularPriceTypography: {
        css: css`
            font-size: 12px;
            color: #666;
            font-weight: 600 !important;
            line-height: 1.17;
            letter-spacing: normal;
            text-decoration: line-through;
            margin-left: 6px;
        `,
    },
    productBrandStyles: {
        color: "#2d2926",
        typographyProps: {
            size: 12,
            weight: 600,
            css: css`
                width: 100%;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                font-size: 10px;
                            `,
                        ],
                        "max",
                    );
                }}
            `,
        },
        hoverStyle: {
            textDecoration: "underline",
        },
    },
    productNameStyles: {
        css: css`
            text-transform: none;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-word;
            font-weight: 600;
            line-height: normal;
        `,
    },
    orderLineInfoItemTitle: {
        weight: "bold",
        size: 14,
        css: css`
            padding-left:15px;
        `,
    },
    qtyTitleStylingBelowlgScreen: {
        css: css`
            font-size: 16px;
            margin-right: 5px;
            line-height: 31px;
        `,
    },
    totalTitleStylingBelowlgScreen: {
        css: css`
            font-size: 16px;
            margin-right: 5px;
            line-height: 31px;
        `,
    },
    minicartMarketingTag: {
        css: css`
            position: relative;
            
            > div {
                position: relative;
                > span {
                    margin-right: 7px;
                }
            }
        `,
    },
    clearanceStirkeprice: {
        css: css`
            color: #666;
            font-size: 12px;
            font-weight: bold;
            text-decoration: line-through;
            line-height: normal;
        `,
    },
    clearanceSaleEnd: {
        css: css`
            color: #0daa00;
            font-size: 12px;
            font-weight: 600;
            line-height: normal;
        `,
    },
    clearancecartContainer: {
        css: css`
            margin-left: 5px;
        `,
    },
};

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const cart = getCurrentCartState(state).value;
    const currentPage = getCurrentPage(state).type;
    const isPdp = currentPage === "ProductDetailsPage";
    const isProductComparePage = currentPage === "ProductComparePage";
    const session = state.context.session;
    const product = getProductState(state, ownProps.cartLine.productId ?? "").value;

    return {
        cart,
        isPdp,
        isProductComparePage,
        cartUrl: getPageLinkByPageType(state, "CartPage")?.url,
        canCheckoutWithCart: canCheckoutWithCart(cart),
        isCartCheckoutDisabled: !cart || isCartCheckoutDisabled(cart),
        isCartEmpty: isCartEmpty(cart),
        checkoutShippingPageUrl: getPageLinkByPageType(state, "CheckoutShippingPage")?.url,
        isAuthenticated: session && (session.isAuthenticated || session.rememberMe) && !session.isGuest,
        session: getSession(state),
        productSettings: getSettingsCollection(state).productSettings,
        product,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const MiniCartLine: FC<Props> = ({
    cartLine,
    cart,
    extendedStyles,
    quantityOrdered,
    qtyOrdered = 1,
    isPdp,
    isProductComparePage,
    product,
    isAuthenticated,
    productSettings,
    onModalClose,
}) => {
    const [styles] = React.useState(() => mergeToNew(miniCartLineStyles, extendedStyles));
    const pricing = cartLine.pricing;
    const language = useSelector((state: CustomApplicationState) => state.context.session.language);
    if (!cartLine || !cart) {
        return null;
    }

    const currencySymbol = cart?.currencySymbol ? cart.currencySymbol : "";
    let unitNetPrice: number = 0;
    let unitListPrice: number = 0;
    let unitListPriceDisplay: string = "";

    if (pricing) {
        ({ price: unitNetPrice } = getUnitNetPrice(pricing, qtyOrdered));
        ({ price: unitListPrice, priceDisplay: unitListPriceDisplay } = getUnitListPrice(pricing, qtyOrdered));
    }
 
    const savingsAmount = Math.round((unitListPrice - unitNetPrice) * 100) / 100;
    var localizedSavingsAmount = "";
    if (language) localizedSavingsAmount = getLocalizedCurrency({ amount: savingsAmount, language, currencySymbol });
    const unitOfMeasureDescription = cartLine?.unitOfMeasureDescription;
    const unitOfMeasureDisplay = cartLine?.unitOfMeasureDisplay
        ? cartLine?.unitOfMeasureDisplay
        : cartLine?.unitOfMeasure;

    var productPrice = "";
    var decimalPrice = "";
    var totalPrice = "";
    var totalDecimalPrice = "";

    if (cartLine.pricing?.actualPrice && cartLine.qtyOrdered) {
        var price = cartLine.pricing?.actualPrice.toString();
        var priceStr = cartLine.pricing?.actualPriceDisplay;
        const withoutDollarSign = priceStr.substring(1);
        const splitedPrice = withoutDollarSign.split(".");
        var split = price.split(".");
        if (splitedPrice.length > 0) productPrice = splitedPrice[0];
        if (splitedPrice.length > 1) {
            decimalPrice = splitedPrice[1];
        }

        price = (cartLine.pricing?.actualPrice * (quantityOrdered ?? cartLine.qtyOrdered)).toFixed(2).toString();
        split = price.split(".");
        if (split.length > 0) {
            totalPrice = split[0];
        }
        if (split.length > 1) {
            totalDecimalPrice = split[1];
        }
    }
    const productContextModel = product as unknown as ProductContextModel;
    const cartLineModel = cartLine as unknown as CartLineModel;
    const productData = productContextModel?.product ? productContextModel?.product : cartLineModel;
    const salesTypes = ["AC", "EV", "SM", "ED"];
    const saletype = productData?.properties["saletype"];
    const checkIfNotSales = saletype !== undefined && !salesTypes.includes(saletype);
    const isClearance = checkIfNotSales && (productData.properties["isClearance"] === "True" || (productData.properties["classificatioN_CODE"] && productData.properties["classificatioN_CODE"].toLowerCase() === "x"));
    const isSale =
        checkIfNotSales &&
        productData.properties["classificatioN_CODE"] !== "X" &&
        productData.properties["onsalenow"] === "1";

    const showSaleEndDate = saleEndDate(pricing);
    const hasPriceSavings = unitNetPrice < unitListPrice;


    const getQuantityOrdered = () => {
        if ((isPdp || isProductComparePage) && quantityOrdered) {
            return quantityOrdered;
        } else {
            return cartLine.qtyOrdered;
        }
    };

    let brandHref = "";

    const formatPrice = (num: string) => {
        // Trim whitespace from input
        const trimmedNum = num.trim();
      
        // Check if the trimmed string is a valid number
        if (!/^-?\d+(\.\d+)?$/.test(trimmedNum)) {
          return num; // Return original if it's not a valid number
        }
      
        const number = parseFloat(trimmedNum);
      
        return new Intl.NumberFormat('en-US', {
          style: 'decimal',
          minimumFractionDigits: 0, 
          maximumFractionDigits: 2,
        }).format(number);
    };

    if (cartLine.brand?.detailPagePath) {
        const detailPagePath = cartLine.brand.detailPagePath;

        if (detailPagePath.includes("/Catalog")) {
            brandHref = detailPagePath;
        } else {
            brandHref = `/Catalog${detailPagePath}`;
        }
    }
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.orderLineInfoTitleGridItem}>
                <GridContainer {...styles.orderLineInfoTitleContainer}>
                    <GridItem {...styles.orderLineInfoItemContainer} width={6}>
                        <Typography {...styles.orderLineInfoItemTitle} as="h4">
                            {translate("Item")}
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.orderLineInfoTotalContainer} width={3}>
                        <Typography {...styles.orderLineInfoTitles} as="h4">
                            {translate("Price")}
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.orderLineInfoTotalContainer} width={1}>
                        <Typography {...styles.orderLineInfoTitles} as="h4">
                            {translate("Qty")}
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.orderLineInfoTotalContainer} width={2}>
                        <Typography {...styles.orderLineInfoTitles} as="h4">
                            {translate("Total")}
                        </Typography>
                    </GridItem>
                </GridContainer>
            </GridItem>
            <GridItem {...styles.orderLineInfoGridItem}>
                <GridContainer {...styles.orderLineInfoContainer}>
                    <GridItem {...styles.productImageGridItem}>
                        <ProductImage product={cartLine} extendedStyles={styles.productImage} />
                        <Hidden above="md">
                            <StyledWrapper {...styles.productErpNumberText}>
                                <Typography>{cartLine.modelNumber}</Typography>
                                <Typography>{cartLine.erpNumber}</Typography>
                            </StyledWrapper>
                        </Hidden>
                    </GridItem>
                    <GridItem {...styles.infoLeftColumn}>
                        <GridContainer {...styles.infoLeftColumnContainer}>
                            <GridItem {...styles.productBrandAndDescriptionGridItem}>
                                {cartLine.brand && (
                                    <Link
                                        {...styles.productBrandStyles}
                                        href={brandHref}
                                        onClick={onModalClose}
                                    >
                                        {cartLine.brand.name}
                                    </Link>
                                )}

                                <Typography as="p" size={14} {...styles.productNameStyles} color="#2d2926">
                                    {cartLine.productName}
                                </Typography>
                                <Hidden below="lg">
                                    <Typography {...styles.productErpNumberText}>
                                        {cartLine.modelNumber}&nbsp; | &nbsp;{cartLine.erpNumber}
                                    </Typography>
                                </Hidden>
                            </GridItem>
                            <GridItem {...styles.mobilePriceGridItem}>
                                <Typography as="span" {...styles.priceTypography} size={20}>
                                    <Typography {...styles.totalSupStyles} as="sup">
                                        {cart.currencySymbol}
                                    </Typography>
                                    <Typography {...styles.priceTotalTypography} as="span">
                                        {formatPrice(productPrice)}
                                    </Typography>
                                    <Typography {...styles.centsSupStyles} as="sup">
                                        {decimalPrice}
                                    </Typography>
                                </Typography>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem {...styles.priceGridItem}>
                        {cartLine && (
                            <StyledWrapper {...styles.minicartMarketingTag}>
                                <MiniCartSaleInfo product={cartLine} isAuthenticated={isAuthenticated}/>
                            </StyledWrapper>
                        )}

                        <Typography as="span" {...styles.priceTypography} size={27}>
                            <Typography {...styles.totalSupStyles} as="sup">
                                {cart.currencySymbol}
                            </Typography>
                            <Typography {...styles.priceTotalTypography} as="span">
                                {formatPrice(productPrice)}
                            </Typography>
                            <Typography {...styles.centsSupStyles} as="sup">
                                {decimalPrice}
                            </Typography>
                            <Typography {...styles.unitSupStyles} as="sup">
                                {getunitOfMeasureDisplay(unitOfMeasureDisplay)}
                            </Typography>
                        </Typography>
                        {hasPriceSavings && (
                            <StyledWrapper {...styles.clearancecartContainer}>
                                {/* Strike through Value */}
                                {cartLine.pricing?.extendedUnitNetPriceDisplay ===
                                    cartLine.pricing?.extendedUnitListPriceDisplay ? (
                                    ""
                                ) : (
                                    <StyledWrapper {...styles.clearanceStirkeprice}>
                                        {cartLine.pricing?.unitListPriceDisplay}
                                    </StyledWrapper>
                                )}
                                {isSale && (
                                    <Typography as="p" {...styles.clearanceSaleEnd}>
                                        {showSaleEndDate && <>Ends {showSaleEndDate}</>}
                                    </Typography>
                                )}
                                {isClearance && productSettings.showSavingsAmount && (
                                    <Typography as="p" {...styles.clearanceSaleEnd}>
                                        Save {localizedSavingsAmount}
                                    </Typography>
                                )}
                                {isClearance && productSettings.showSavingsAmount && (
                                    <Typography as="p" {...styles.clearanceSaleEnd}>
                                        {showSaleEndDate && <>Ends {showSaleEndDate}</>}
                                    </Typography>
                                )}
                            </StyledWrapper>
                        )}
                    </GridItem>
                    <GridItem {...styles.qtyOrderedGridItem}>
                        <Hidden above="md">
                            <Typography {...styles.qtyTitleStylingBelowlgScreen}>{translate("Qty")}</Typography>
                        </Hidden>
                        <Typography size={16} weight="bold">
                            {getQuantityOrdered()}
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.totalOrderedGridItem}>
                        <Hidden above="md">
                            <Typography {...styles.totalTitleStylingBelowlgScreen}>{translate("Total")}</Typography>
                        </Hidden>
                        <Typography {...styles.totalSupStyles} as="sup">
                            {cart.currencySymbol}
                        </Typography>
                        <Typography {...styles.priceTotalTypography} as="span">
                            {formatPrice(totalPrice)}
                        </Typography>
                        <Typography {...styles.centsSupStyles} as="sup">
                            {totalDecimalPrice}
                        </Typography>
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};

export default connect(mapStateToProps)(MiniCartLine);
